import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<span style="vertical-align: text-top; margin-right: 7px">{{
      score
    }}</span>
    <risk-heat-meter [risk]="rating"></risk-heat-meter> `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingPillComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  score: string;
  rating: string;

  ngOnInit(): void {
    super.ngOnInit();
    this.score = this.data[this.key];
    this.rating = this.data[this.key.replace('Score', 'Grade')];
  }
}
